import { BaseListResponse, ListItemLoader, RequestFactory, RequestSender } from '../core'
import { AxiosResponse } from 'axios'

export { BaseListResponse, ListItemLoader, RequestSender }

export const IframelyRequestFactory = new RequestFactory({
  baseUrl: 'https://iframe.ly/api',
  timeout: 5000,
  contentType: 'application/json',
  withCredentials: false
})

export interface GetOembedRequest {
  url: string
  maxwidth?: number
  maxheight?: number
}

interface GetOembedRequestParams extends GetOembedRequest {
  key: string
}

export type OembedType = 'photo' | 'video' | 'link' | 'rich'

export interface BaseOembedResponse {
  type: OembedType
  version: string
  title?: string
  author_name?: string
  author_url?: string
  provider_name?: string
  provider_url?: string
  cache_age?: number
  thumbnail_url?: string
  thumbnail_width?: number
  thumbnail_height?: number
  html?: string
  description?: string
}

export interface OembedPhotoResponse extends BaseOembedResponse {
  type: 'photo'
  url: string
  width: number
  height: number
}

export interface OembedVideoResponse extends BaseOembedResponse {
  type: 'video'
  html: string
  width: number
  height: number
}

export interface OembedLinkResponse extends BaseOembedResponse {
  type: 'link'
  url?: string
}

export interface OembedRichResponse extends BaseOembedResponse {
  type: 'rich'
  html: string
  width: number
  height: number
}

export type GetOembedResponse = OembedPhotoResponse | OembedVideoResponse | OembedLinkResponse | OembedRichResponse

export interface IIframelyEndpoint {
  getOembed(request: GetOembedRequest): Promise<AxiosResponse<GetOembedResponse>>
}

export default class IframelyEndpoint implements IIframelyEndpoint {
  getOembed(request: GetOembedRequest): Promise<AxiosResponse<GetOembedResponse>> {
    const path = '/oembed'
    // process.env.IFRAMELY_API_HASHED_KEY
    // MD5 ハッシュで暗号化されたiframely API_KEY
    const params: GetOembedRequestParams = Object.assign({}, request, {
      key: process.env.IFRAMELY_API_HASHED_KEY
    })
    return IframelyRequestFactory.getRequest().execute<GetOembedRequestParams, GetOembedResponse>(path, params)
      .then(response => response)
  }
}
